// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"d14a9fed133c47ab68e1","691":"a9b99ae91a431e3a01a0"}[chunkId] + ".js";
};